import clsx from "clsx";

import { ArcadeTimer } from "../../../shared/components/arcade-timer.component";
import { handleGoogleDriveImageUrl } from "../../../shared/utils";

export function MatchUpBanner({
  pairsNumber,
  brand,
  brandLogo,
  brandDescription,
  pairsCompleted,
  timerRunning,
  handleTimeout,
}: {
  pairsNumber: number;
  brand: string;
  brandLogo: string;
  brandDescription: string;
  pairsCompleted: number;
  timerRunning: boolean;
  handleTimeout: () => void;
}) {

  return (
    <div
      className={clsx(
        "match-up--banner",
        pairsCompleted === pairsNumber && "round--completed"
      )}
    >
      <div className="match-up--banner-entries">
        <span>+{pairsNumber * 1}</span> points
      </div>
      <div className="match-up--banner-matches">
        <div className="matches__label">
          MATCHES: {pairsCompleted}/{pairsNumber}
        </div>
        <span className="matches__sublabel label--desktop">THIS ROUND SPONSORED BY {brand}</span>
        <span className="matches__sublabel label--mobile">SPONSORED BY {brand}</span>
        <div className="brand__logo">
          <img src={handleGoogleDriveImageUrl(brandLogo)} alt="Brand logo" />
        </div>
      </div>
      <div className="match-up--banner-timer">
        <ArcadeTimer isRunning={timerRunning} time={60} onTimeout={handleTimeout} />
      </div>
      <div className="match-up--banner-sponsor">
        <div className="brand__logo">
          <img src={handleGoogleDriveImageUrl(brandLogo)} alt="Brand logo" />
        </div>
        <span className="sponsor__description">{brandDescription}</span>
      </div>
    </div>
  );
}
